import { Component, OnInit } from "@angular/core";

@Component({
  selector: "footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  partialImagePath: string = "../assets/images/";

  constructor() {}

  ngOnInit() {}

  getFullImagePath(img) {
    return this.partialImagePath + img + ".png";
  }

  getYear() {
    let d = new Date();
    return d.getFullYear();
  }
}
